// extracted by mini-css-extract-plugin
export default {"container":"Robot_container__Ahrur","panel":"Robot_panel__RF8lj","wrapper":"Robot_wrapper__45NkY","info":"Robot_info__dSE0N","unit":"Robot_unit__h3RiF"};